import { getKeywords } from "../../api/getKeywords";
import { uploadText } from "../../api/uploadText";
import { franc } from "franc";
import { commonErrorToastMessage } from "../../components/toastify/AllToastifyErrors";
import {
  keywordsDummyResponse,
  keywordsForElemantarySchool,
  keywordsForJuniorClg,
  keywordsForGraduate,
  keywordsForDoctorate,
  keywordsForCorporate } from "../../data/sampleTextDummyResponse/dummyResponsesSampleText";

/**
 *
 * @param {string} title - The title of the content.
 * @param {string} domain - The domain of the content.
 * @param {number} wordCount - The word count of the content.
 * @param {File} selectedFile - The selected file, if any.
 * @param {string} uploadedContent - The content uploaded from a file.
 * @param {string} content - The content from text input.
 * @param {function} setContent - A function to set the content.
 * @param {function} setIsLoading - A function to set loading state.
 * @param {function} setIsTextLoading - A function to set text loading state.
 * @param {function} setTitle - A function to set the title.
 * @param {function} setIsNetworkError - A function to set network error state.
 * @param {function} setResponseData - A function to set response data.
 * @param {RefObject} titleInputRef - A reference to the title input element.
 * @param {RefObject} .domainSelectRef - A reference to the domain select element.
 * @param {function} params.navigate - A function for navigation.
 * @param {any} params.response - The response data (if any).
 */

function removeAllHTMLTags(text) {
  // Remove all HTML tags
  let cleaned = text.replace(/<[^>]+>/g, '');

  // Optional: Trim extra spaces/newlines (if needed)
  cleaned = cleaned.replace(/\s+/g, ' ').trim();

  return cleaned;
}

export const handleSubmitContent = async ({
  title,
  domain,
  wordCount,
  selectedFile,
  uploadedContent,
  content,
  setContent,
  setIsLoading,
  setIsTextLoading,
  setTitle,
  setIsNetworkError,
  setResponseData,
  titleInputRef,
  domainSelectRef,
  navigate,
  response,
  user
}) => {
  // Check if title is empty
  if (!title) {
    commonErrorToastMessage("Please add title for your content.");
    titleInputRef?.current.focus();
    return;
  }

  // Check if domain is empty
  if(!user.isGPT){
    if (!domain) {
      commonErrorToastMessage(
        "Please choose the domain to which your content belongs."
      );
      domainSelectRef?.current.focus();
      return;
    }
  }

  // Check if word count is less than 300
  if (wordCount < 300 || wordCount > 3000) {
    commonErrorToastMessage(
      "Word count must be between 300-3000 for question generation."
    );
    return;
  }

  // Check if text is in English or not
  
  const text = content;
  const parser = new DOMParser().parseFromString(text, 'text/html');
  if (text) {
    const languageCode = franc(parser.body.innerText, { minLength: 100 }); // Minimum length to consider for language detection
    if (languageCode !== "eng") {
      console.log("Please provide a file containing only English text.");

      commonErrorToastMessage(
        "Kindly input text written in the English language exclusively."
      );

      setIsLoading(false);

      return content; // Return the existing content if the file size exceeds the limit
    }
  }

  try {
    setIsLoading(true);
    window.title = title;

    if (selectedFile && user.isGPT) {
      // Handle file upload
      setContent(uploadedContent);
      setTitle(title);
      setResponseData(response.data);
    } else if (content) {
      // Handle text input
      setIsTextLoading(true);

      // This is mechanism is only for Sample Text
      const isSampleTextClicked = localStorage.getItem("isSampleButtonClicked");

      const email = localStorage.getItem("email");

      // Upload text text API call
      let response = "";
      let filteredContent = ""; 
      if (isSampleTextClicked === "true") {
        console.log("checkIsSampleTextClickedTrue");
        // We need to use the "uploadText" API, which will generate a unique doc_id each time, aiding in preserving questions and facilitating their storage on the History Page.
        const uploadTextResponse = await uploadText(content, title, email, domain , wordCount);
        response = uploadTextResponse;
      } else {
       filteredContent = await removeAllHTMLTags (content);
        const uploadTextResponse = await uploadText(filteredContent, title, email, domain , wordCount);
        response = uploadTextResponse;
         if (response !== null) {
          localStorage.setItem('QAreqbody',JSON.stringify(response?.data))
          setContent(filteredContent);
        }
      }
      setResponseData(response.data);

      // Get keywords for the uploaded content
      let keywordsResponse = "";

      if (isSampleTextClicked === "true") {
        // keywordsDummyResponse is the dummy response which contains static keywords for Sample Text
        const keywordsResponseTemp = keywordsDummyResponse;

        switch (title){
          case "The Lion and the Mouse":
            keywordsResponse = keywordsForElemantarySchool;
            break;
          
          case "AI in Drug Discovery and Development":
            keywordsResponse = keywordsForJuniorClg;
            break;

          case "The Future of Renewable Energy Technologies":
          keywordsResponse = keywordsForGraduate;  
          break;

          case "Adoption of AI in Biology":
            keywordsResponse = keywordsForDoctorate;
            break;

          case "Mentorship and Succession Planning":
            keywordsResponse = keywordsForCorporate;
            break;

          default:
            keywordsResponse = keywordsResponseTemp;
        }
      } else {
        if (!response.data?.top_keywords) {
          const keywordsResponseTemp = await getKeywords(
            response.data.doc_id,
            response.data.title,
            filteredContent,
            response.data.total_words,
          );
          keywordsResponse = keywordsResponseTemp;
        } else {
          keywordsResponse = {  data: { keywords: response.data } };
        }
      }

      setIsTextLoading(false);

      localStorage.setItem("content", filteredContent);
      localStorage.setItem("title", title);
      localStorage.setItem("doc_id", response.data.doc_id);
      localStorage.setItem("domain", domain);
      localStorage.setItem(
        "keywordsResponse",
        JSON.stringify(keywordsResponse)
      );
      
      let totalwordcount = parseInt(response.data.total_words, 10) || 0;

      localStorage.setItem("total_words",totalwordcount.toString());
      
      // Navigate to the keywords page
      navigate(`/keywords`);

      setContent("");
      setResponseData(response);
    }

    setIsLoading(false);
  } catch (error) {
    // Handle network error
    setIsNetworkError(true);
    setIsLoading(false);
    setIsTextLoading(false);
    console.error("Error while making the API request:", error);
    commonErrorToastMessage("Error while generating keywords.");
  } finally {
    if (!selectedFile) {
      setIsLoading(false);
    }
  }
};

// import { getKeywords } from "../../api/getKeywords";
// import { getdisseqtKeywords } from "../../api/disseqtkeyword";
// import { uploadText } from "../../api/uploadText";
// import { franc } from "franc";
// import { commonErrorToastMessage } from "../../components/toastify/AllToastifyErrors";
// import {
//   keywordsDummyResponse,
//   keywordsForElemantarySchool,
//   keywordsForJuniorClg,
//   keywordsForGraduate,
//   keywordsForDoctorate,
//   keywordsForCorporate,
// } from "../../data/sampleTextDummyResponse/dummyResponsesSampleText";

// /**
//  *
//  * @param {string} title - The title of the content.
//  * @param {string} domain - The domain of the content.
//  * @param {number} wordCount - The word count of the content.
//  * @param {File} selectedFile - The selected file, if any.
//  * @param {string} uploadedContent - The content uploaded from a file.
//  * @param {string} content - The content from text input.
//  * @param {function} setContent - A function to set the content.
//  * @param {function} setIsLoading - A function to set loading state.
//  * @param {function} setIsTextLoading - A function to set text loading state.
//  * @param {function} setTitle - A function to set the title.
//  * @param {function} setIsNetworkError - A function to set network error state.
//  * @param {function} setResponseData - A function to set response data.
//  * @param {RefObject} titleInputRef - A reference to the title input element.
//  * @param {RefObject} .domainSelectRef - A reference to the domain select element.
//  * @param {function} params.navigate - A function for navigation.
//  * @param {any} params.response - The response data (if any).
//  */

// function removeAllHTMLTags(text) {
//   // Remove all HTML tags
//   let cleaned = text.replace(/<[^>]+>/g, "");

//   // Optional: Trim extra spaces/newlines (if needed)
//   cleaned = cleaned.replace(/\s+/g, " ").trim();

//   return cleaned;
// }

// function processGuardrailKeywords(disseqtResponse, guardrailParams) {
//   console.log("params received disseqtResponse :- ", disseqtResponse);
//   console.log("params received guardrailParams :- ", guardrailParams);
  
//   const isAdmin = guardrailParams.is_admin === "true" || true;
  
//   // Extract OpenAI guardrails results (all users get this)
//   const openaiCategories = disseqtResponse?.data?.openai_gurdrails_results?.categories || [];
//   const openaiKeywords = openaiCategories.map((item) => item.category);

//   let allKeywords = [];
//   let processedData = {
//     openai_keywords: openaiKeywords,
//     openai_categories: openaiCategories,
//   };

//   if (isAdmin) {
//     // For admin users: include disseqt validators as keywords
//     const disseqtValidators = disseqtResponse?.data?.disseqt_gurdrails_results || {};
    
//     // Extract InputPromptInjectionValidator
//     const promptInjectionValidator = disseqtValidators.InputPromptInjectionValidator;
//     const promptInjectionKeyword = promptInjectionValidator?.validator_name || "prompt-injection";
//     const promptInjectionPassed = promptInjectionValidator?.threshold_validated_result === "Pass";

//     // Extract InvisibleTextValidator
//     const invisibleTextValidator = disseqtValidators.InvisibleTextValidator;
//     const invisibleTextKeyword = invisibleTextValidator?.validator_name || "invisible-text";
//     const invisibleTextPassed = invisibleTextValidator?.threshold_validated_result === "Pass";

//     // Combine all keywords: OpenAI categories + disseqt validators
//     allKeywords = [
//       ...openaiKeywords,
//       promptInjectionKeyword,
//       invisibleTextKeyword,
//     ];

//     processedData = {
//       ...processedData,
//       disseqt_validators: [
//         {
//           name: promptInjectionKeyword,
//           passed: promptInjectionPassed,
//           validator: promptInjectionValidator,
//         },
//         {
//           name: invisibleTextKeyword,
//           passed: invisibleTextPassed,
//           validator: invisibleTextValidator,
//         },
//       ],
//       isAdmin: true,
//     };
//   } else {
//     // For non-admin users: only OpenAI guardrails
//     allKeywords = openaiKeywords;
//   }

//   return {
//     data: {
//       keywords: allKeywords,
//       ...processedData,
//       disseqtRaw: disseqtResponse?.data || {},
//       isDisseqt: true,
//     },
//   };
// }

// export const handleSubmitContent = async ({
//   title,
//   domain,
//   wordCount,
//   selectedFile,
//   uploadedContent,
//   content,
//   setContent,
//   setIsLoading,
//   setIsTextLoading,
//   setTitle,
//   setIsNetworkError,
//   setResponseData,
//   titleInputRef,
//   domainSelectRef,
//   navigate,
//   response,
//   user,
// }) => {
//   // Check if title is empty
//   if (!title) {
//     commonErrorToastMessage("Please add title for your content.");
//     titleInputRef?.current.focus();
//     return;
//   }

//   // Check if domain is empty
//   if (!user.isGPT) {
//     if (!domain) {
//       commonErrorToastMessage(
//         "Please choose the domain to which your content belongs.",
//       );
//       domainSelectRef?.current.focus();
//       return;
//     }
//   }

//   // Check if word count is less than 300
//   if (wordCount < 300 || wordCount > 3000) {
//     commonErrorToastMessage(
//       "Word count must be between 300-3000 for question generation.",
//     );
//     return;
//   }

//   // Check if text is in English or not

//   const text = content;
//   const parser = new DOMParser().parseFromString(text, "text/html");
//   if (text) {
//     const languageCode = franc(parser.body.innerText, { minLength: 100 }); // Minimum length to consider for language detection
//     if (languageCode !== "eng") {
//       console.log("Please provide a file containing only English text.");

//       commonErrorToastMessage(
//         "Kindly input text written in the English language exclusively.",
//       );

//       setIsLoading(false);

//       return content; // Return the existing content if the file size exceeds the limit
//     }
//   }

//   try {
//     setIsLoading(true);
//     window.title = title;

//     if (selectedFile && user.isGPT) {
//       // Handle file upload
//       setContent(uploadedContent);
//       setTitle(title);
//       setResponseData(response.data);
//     } else if (content) {
//       // Handle text input
//       setIsTextLoading(true);

//       // This is mechanism is only for Sample Text
//       const isSampleTextClicked = localStorage.getItem("isSampleButtonClicked");

//       const email = localStorage.getItem("email");

//       // Upload text text API call
//       let response = "";
//       let filteredContent = "";
//       if (isSampleTextClicked === "true") {
//         console.log("checkIsSampleTextClickedTrue");
//         // We need to use the "uploadText" API, which will generate a unique doc_id each time, aiding in preserving questions and facilitating their storage on the History Page.
//         const uploadTextResponse = await uploadText(
//           content,
//           title,
//           email,
//           domain,
//           wordCount,
//         );
//         response = uploadTextResponse;
//       } else {
//         filteredContent = await removeAllHTMLTags(content);
//         const uploadTextResponse = await uploadText(
//           filteredContent,
//           title,
//           email,
//           domain,
//           wordCount,
//         );
//         response = uploadTextResponse;
//         if (response !== null) {
//           localStorage.setItem("QAreqbody", JSON.stringify(response?.data));
//           setContent(filteredContent);
//         }
//       }
//       setResponseData(response.data);

//       // Get keywords for the uploaded content
//       let keywordsResponse = "";

//       if (isSampleTextClicked === "true") {
//         // keywordsDummyResponse is the dummy response which contains static keywords for Sample Text
//         const keywordsResponseTemp = keywordsDummyResponse;

//         switch (title) {
//           case "The Lion and the Mouse":
//             keywordsResponse = keywordsForElemantarySchool;
//             break;

//           case "AI in Drug Discovery and Development":
//             keywordsResponse = keywordsForJuniorClg;
//             break;

//           case "The Future of Renewable Energy Technologies":
//             keywordsResponse = keywordsForGraduate;
//             break;

//           case "Adoption of AI in Biology":
//             keywordsResponse = keywordsForDoctorate;
//             break;

//           case "Mentorship and Succession Planning":
//             keywordsResponse = keywordsForCorporate;
//             break;

//           default:
//             keywordsResponse = keywordsResponseTemp;
//         }
//       } else {
//         if (!response.data?.top_keywords) {
//           // Call guardrail API for specific users. Set is_admin explicitly to "true" or "false"
//           // so query params sent to the server are predictable.
//           const guardrailUsers = [
//             "Abhishek.Nighojkar@harbingergroup.com",
//             "Umeshk@harbingergroup.com",
//           ];

//           const isAdminUser = guardrailUsers.includes(email);
//           // Extra params for guardrail API — email is replaced with the logged-in user's email
//           const guardrailParams = {
//             Usergpt_key: "LIMITED",
//             email: email,
//             user_type: "gpt_user",
//             // Use string values to ensure query param serialization is explicit
//             is_admin: isAdminUser ? true : false,
//           };

//           // Call the guardrail (disseqt) API
//           const disseqtResponse = await getdisseqtKeywords(
//             response.data.doc_id,
//             response.data.title,
//             filteredContent,
//             response.data.total_words,
//             guardrailParams,
//           );
//           console.log("disseqtResponse :", disseqtResponse);

//           // Normalize disseqt response: it returns data as an array of { category, flagged, score }
//           // Extract category names where flagged is false as the keyword list,
//           // OR fall back to all category names if none are flagged
//           const disseqtData = Array.isArray(disseqtResponse?.data)
//             ? disseqtResponse.data
//             : [];

//              const keywords = disseqtData.map((item) => item.category);

//           // Store in the same shape as getKeywords so Keywords.jsx works without changes
//           keywordsResponse = {
//             data: {
//               keywords: keywords,
//               // Preserve the raw disseqt data for any future use
//               disseqtRaw: disseqtData,
//               isDisseqt: true,
//             },
//           };

//           // Process guardrail keywords based on user type
//           keywordsResponse = processGuardrailKeywords(disseqtResponse, guardrailParams);

//           localStorage.setItem(
//             "guardrailResults",
//             JSON.stringify({
//               openai_gurdrails_results:
//                 disseqtResponse?.data?.openai_gurdrails_results ?? null,
//               disseqt_gurdrails_results:
//                 disseqtResponse?.data?.disseqt_gurdrails_results ?? null,
//               isAdmin: isAdminUser,
//             }),
//           );
//         } else {
//           keywordsResponse = { data: { keywords: response.data } };
//         }
//       }

//       setIsTextLoading(false);

//       localStorage.setItem("content", filteredContent || content);
//       localStorage.setItem("title", title);
//       localStorage.setItem("doc_id", response.data.doc_id);
//       localStorage.setItem("domain", domain);
//       localStorage.setItem("keywordsResponse",JSON.stringify(keywordsResponse));
//       let totalwordcount = response.data.total_words;
//       localStorage.setItem("total_words", totalwordcount.toString());

//       // Navigate to the keywords page
//       navigate(`/keywords`);

//       setContent("");
//       setResponseData(response);
//     }

//     setIsLoading(false);
//   } catch (error) {
//     // Handle network error
//     setIsNetworkError(true);
//     setIsLoading(false);
//     setIsTextLoading(false);
//     console.error("Error while making the API request:", error);
//     commonErrorToastMessage("Error while generating keywords.");
//   } finally {
//     if (!selectedFile) {
//       setIsLoading(false);
//     }
//   }
// };
